export default __webpack_public_path__ + "static/media/web.bf420812.svg";